import { combineReducers } from 'redux';
//Admin
import DashboardReducer from './adminreducers/DashboardReducers';
import AdminDonorlist from './adminreducers/AdDonorReducers';
import AdminFundmanagerlist from './adminreducers/AdFundmanReducers';
import AdminOrganizationlist from './adminreducers/AdOrgReducers';
import AdminCountrylist from './adminreducers/AdCountryReducers';
import AdminNeedslist from './adminreducers/AdNeedsReducers';
import AdDonorDocument from './adminreducers/AdViewDonorReducers';
import AdFundDocument from './adminreducers/AdViewFundReducers';
import AdOrgDocument from './adminreducers/AdViewOrgReducers';
//Donor
import DdashboardReducer from './donorreducers/DDashboardReducer';
import DOrgPrintTranscriptReducers from './donorreducers/DOrgPrintTranscriptReducers';
import DurgentReducer from './donorreducers/DUrgentNeedReducer';
import DneedReducer from './donorreducers/DNeedreducer';
import DneedViewReducer from './donorreducers/DonorNeedViewReducer';
import ddocumentReducer from './donorreducers/DDocumentReducer'
import DDonationsReducers from './donorreducers/DDonationsReducers';
import DFeedbackReducers from './donorreducers/DFeedbackReducers';
import Newdonationreducer from './donorreducers/NewDonationReducer';
import Dchart from './donorreducers/DonorChatReducer';
import DaddFeedback from './donorreducers/DAddFeedback';
import DFundManagerRReducers from '../reducers/donorreducers/DFundmangerRReducer';
import DOrganisationReducer from '../reducers/donorreducers/DOrganizationReducer';
import DFundtranscriptReducer from '../reducers/donorreducers/DFundTranscriptReducer'
import Dprofilereducer from '../reducers/donorreducers/DProfileReducer'

//fundmanager
import DashboardReducers from './fundManagersreducers/DashboardReducers';
import OrgapplicationsReducers from './fundManagersreducers/OrgapplicationsReducers';
import DocumentReducers from './fundManagersreducers/DocumentReducers';
import FeedbacksReducers from './fundManagersreducers/FeedbacksReducers';
import DonationsReducers from './fundManagersreducers/DonationsReducers';
import DonorReportsReducers from './fundManagersreducers/DonorReportsReducers';
import OrganizationReportReducer from './fundManagersreducers/OrganizationReportReducer';
import AddFeedbacksReducers from './fundManagersreducers/AddFeedbacksReducers';
import ViewOrgReducers from './fundManagersreducers/ViewOrgReducers';
import FDonorReportsTranscriptReducers from './fundManagersreducers/FDonorReportsTranscriptReducers';
import FOrgReportsTranscriptReducers from './fundManagersreducers/FOrgReportsTranscriptReducers' ;
import FProfileReducers from './fundManagersreducers/FProfileReducers';

//Organization
import OrgDashboardReducer from './organizationreducers/OrgDashboardReducer';
import OrgNeedsReducers from './organizationreducers/OrgNeedsReducers';
import OrgDonorReportGenReducers from './organizationreducers/OrgDonorReportGenReducers';
import OrgDonationsReducers from './organizationreducers/OrgDonationsReducers';
import OrgDocumentsReducers from './organizationreducers/OrgDocumentsReducers';
import OrgFeedbacksReducers from './organizationreducers/OrgFeedbacksReducers';
import OrgProfileReducers from './organizationreducers/OrgProfileReducers';
import OrgApplicationsReducers from './organizationreducers/OrgApplicationsReducers';
import OrgDonorReportsReducers from './organizationreducers/OrgDonorReportsReducers';
import OrgFundReportsReducers from './organizationreducers/OrgFundReportsReducers';
import OrgAddFeedbackReducer from './organizationreducers/OrgAddFeedbackReducer';
import Orgcounrtry from './organizationreducers/OrgSearchfundReducers';
import OrgAddNeedsReducers from './organizationreducers/OrgAddNeedsReducers';
import OrgNeedsViewReducers from './organizationreducers/OrgNeedsViewReducers';
import OrgAppApplications from '../reducers/organizationreducers/OrgApplyAppReducers';
import OrgappView from '../reducers/organizationreducers/OrgViewAppReducers';
import OrgDonarChatReducers from './organizationreducers/OrgDonorChatReducers';
import OrgFundRepGenReducers from './organizationreducers/OrgFunRepGenReducers';
import OrgEditNeedsReducers from './organizationreducers/OrgEditNeedsReducers';

//resetpassword
import ResetPasswordReducers from './ResetPasswordReducers';
import RegisterReducers from './RegisterReducers';

//mobile
import MobdonationsReducer from './mobilereducers/MobDonationsReducer';
import MobDashboardReducers from './mobilereducers/MobDashboardReducers';

const rootReducer = combineReducers({
  //Admin
  addashboard: DashboardReducer,
  addonorlist: AdminDonorlist,
  adfundmanagerlist: AdminFundmanagerlist,
  adorglist: AdminOrganizationlist,
  adcounrtylist: AdminCountrylist,
  adneedsist: AdminNeedslist,
  addonordocument: AdDonorDocument,
  adfunddocument: AdFundDocument,
  adorgdocument: AdOrgDocument,

  //Donor
  ddashboard: DdashboardReducer,
  durgentreducer: DurgentReducer,
  dneed: DneedReducer,
  dneedview:DneedViewReducer,
  ddonation:DDonationsReducers,
  ddocument:ddocumentReducer,
  dfeedback:DFeedbackReducers,
  newdonationreducer:Newdonationreducer,
  donorchat:Dchart,
  daddfeedback:DaddFeedback,
  dfundreports:DFundManagerRReducers,
  dorganisationreports:DOrganisationReducer,
  dfundtranscript:DFundtranscriptReducer,
  dprofile:Dprofilereducer,
  dorgprint:DOrgPrintTranscriptReducers,
 
 //Fundmanager
 funmdashboard: DashboardReducers,
 fmapp:OrgapplicationsReducers,
 fmdocm:DocumentReducers,
 fmfeedbacks:FeedbacksReducers,
 fmdonation:DonationsReducers,
 fmdonorreports:DonorReportsReducers,
 fmorgreports:OrganizationReportReducer,
 fmaddfeedback:AddFeedbacksReducers,
 orgapplication:ViewOrgReducers,
  donorreports:FDonorReportsTranscriptReducers,
  orgreports :FOrgReportsTranscriptReducers,
  profiledata:FProfileReducers,


  //Organization
  orgdashboard:OrgDashboardReducer,
  orgneed:OrgNeedsReducers,
  orgdon:OrgDonationsReducers,
  orgpro:OrgProfileReducers,
  orgdoc:OrgDocumentsReducers,
  orgfeed:OrgFeedbacksReducers,
  orgapps:OrgApplicationsReducers,
  orgdonrep:OrgDonorReportsReducers,
  orgfundrep:OrgFundReportsReducers,
  orgaddfeed:OrgAddFeedbackReducer,
  orgcountry:Orgcounrtry,
  orgaddneed:OrgAddNeedsReducers,
  orgneedsview:OrgNeedsViewReducers,
  orgappapplication:OrgAppApplications,
  orgapplicationview:OrgappView,
  orgchat:OrgDonarChatReducers,
  orgfgen:OrgFundRepGenReducers,
  orgdgen:OrgDonorReportGenReducers,
  orgeditneed:OrgEditNeedsReducers,


  //ResetPassword
  resetpasswords:ResetPasswordReducers,
  register:RegisterReducers,

  //mobile
  mobiledash:MobdonationsReducer,
  mob:MobDashboardReducers 
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
